import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./App";
import {AuthProvider} from "./context/AuthContext";
import {BrowserRouter} from "react-router-dom";

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <BrowserRouter>
            <AuthProvider>
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </AuthProvider>
        </BrowserRouter>

    );
}
